import { useMutation, useQuery, useQueryClient } from "react-query";
import { customApi } from "../../../CustomHoock/CustomApi";
import axiosInstance from "../../../Axios/axios";
import { baseApiUrl } from "../../../env";

const useGetUserInfo = (reqUnitsBody ) => {
    return useQuery(
      ["GetUserInfo", reqUnitsBody],
      () =>customApi({
          apiType: "get",
          url: "/api/v1/Account/GetUserById",
          reactQuery: reqUnitsBody,
          queryparameters:'userId',
        }),
      {
        enabled: !!reqUnitsBody,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        select: (data) => {
          let res = data?.data.data;
          return res;
        },
      }
    );
  };
  const useEditUser = (handleSuccess, handleFailed) => {
    const queryClient = useQueryClient();
    return useMutation(
      async(body)=>{
        return await axiosInstance.put(
            `${baseApiUrl}/api/v1/Account/EditUser`,
            body,
            {
             headers:{
                 "Content-Type": "multipart/form-data"
               }
            }
        )
      },
      {
        onSuccess: () => {
            queryClient.invalidateQueries("GetUserInfo");
              window.location.href = "/";
           // handleSuccess();
          
        },
        onError: () => {
          //handleFailed();
        },
      }
    );
  };
  const useChangePasswordProfile=(handleSuccess, handleFailed)=>{
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/Account/ChangeUserPassword",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: () => {
        handleSuccess("باموفقیت تغییر یافت");
        
      },
      onError: (error) => {
        const resourceKeyList =
        error?.response?.data?.resourceKeyResult?.resourceKeyList;
        if(resourceKeyList){
          resourceKeyList.forEach((errorListItem) => {
            const element = errorListItem.resourceKeys;
            element.forEach((errorText) => {
              handleFailed(errorText);
            });
          });
        }else{
          handleFailed('خطایی رخ داده است');
        }
      },
    }
  );
  }

  const useGetAllNotification=(userId)=>{
    return useQuery(
      ["GetAllNotification", userId],
      () =>customApi({
          apiType: "post",
          url: "/api/v1/User/GetAllUnreadNotifications",
          requestBody: userId, 
        reactQuery: "query",
        }),
      {
        enabled: !!userId,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        select: (data) => {
          let res = data?.data.data;
          return res;
        },
      }
    );
  }
  const useSeenNotification=()=>{
    const queryClient = useQueryClient();
    return useMutation(
      (messageId) =>
        customApi({
          apiType: "post",
          url: "/api/v1/User/SeenNotification",
          reactQuery: "mutate",
          requestBody: messageId,
        }),
      {
        onSuccess: () => {
            queryClient.invalidateQueries("GetAllNotification");          
        },
        
      }
    );
  }
  const useSeenAllNotification=()=>{
    const queryClient = useQueryClient();
    return useMutation(
      (messageId) =>
        customApi({
          apiType: "post",
          url: "/api/v1/User/SeenAllNotifications",
          reactQuery: "mutate",
          requestBody: messageId,
        }),
      {
        onSuccess: () => {
            queryClient.invalidateQueries("GetAllNotification");
          
        },
        onError: () => {
        },
      }
    );
  }
  export{useGetUserInfo,useEditUser,useChangePasswordProfile,useGetAllNotification,useSeenNotification,useSeenAllNotification}